import { render, staticRenderFns } from "./LoggerDetails.vue?vue&type=template&id=6c383edf"
import script from "./LoggerDetails.vue?vue&type=script&lang=js"
export * from "./LoggerDetails.vue?vue&type=script&lang=js"
import style0 from "./LoggerDetails.vue?vue&type=style&index=0&id=6c383edf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports